import { createStore } from 'vuex';

import auth from './auth';
import users from './users';
import labels from './labels';
import settings from './settings';
import locations from './locations';
import purchases from './purchases';
import sales from './sales';
import addresses from './addresses';
import serial from './serial';


export default createStore({
  modules: {
    auth,
    users,
    labels,
    settings,
    locations,
    purchases,
    sales,
    addresses,
    serial,
  }
});